import { setProblemAsCompleted, setLessonAsCompleted } from "../../../../services/userService";



export function CheckCode(studentCode, output, checkboxes, user, lessonID) {



    if (checkboxes.checkbox1 === false) {
        const testResult = true
        if (testResult) {
            setProblemAsCompleted(lessonID + "P1", user.uid);
            checkboxes.checkbox1 = testResult;
            // console.log("Problem 1 passed");
        } else {
            console.log("Test Failed for problem1: 'age' variable of type int is not declared correctly.");
        }


    }


    if (checkboxes.checkbox1 === true ) {
        setLessonAsCompleted(lessonID, user.uid);
    }

    return checkboxes;
}